// Leichtgewichtiges, abhängigkeitsfreies Toast- + Confirm-System (imperativ aufrufbar).
// Ersetzt blockierende window.alert()/window.confirm().
let listeners = [];
let idSeq = 0;

function emit(action) {
  listeners.forEach((l) => l(action));
}

// Vom NotificationHost genutzt
export function subscribe(fn) {
  listeners.push(fn);
  return () => { listeners = listeners.filter((l) => l !== fn); };
}

// Toast mit explizitem Typ: 'success' | 'danger' | 'info' | 'warning'
export function toast(message, type = 'info', timeout = 4500) {
  emit({ kind: 'toast', toast: { id: ++idSeq, message: String(message), type, timeout } });
}

// Ersetzt alert(): erkennt Erfolg/Fehler grob am Text und färbt entsprechend.
export function notify(message) {
  const m = String(message).toLowerCase();
  let type = 'info';
  if (/(erfolg|gespeichert|erstellt|aktualisiert|gelöscht|hinzugefügt|versendet|gesendet|fertig|willkommen)/.test(m)) {
    type = 'success';
  } else if (/(fehler|error|fehlgeschlagen|ungültig|nicht möglich|konnte nicht|bitte|erforderlich|muss|fehlt)/.test(m)) {
    type = 'danger';
  }
  toast(message, type);
}

export const notifySuccess = (m) => toast(m, 'success');
export const notifyError = (m) => toast(m, 'danger');

// Ersetzt window.confirm(): liefert ein Promise<boolean>.
export function confirmDialog(message, options = {}) {
  const {
    title = 'Bestätigen',
    confirmText = 'OK',
    cancelText = 'Abbrechen',
    danger = false,
  } = options;
  return new Promise((resolve) => {
    emit({ kind: 'confirm', confirm: { id: ++idSeq, message: String(message), title, confirmText, cancelText, danger, resolve } });
  });
}
